(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-columns"]) return;
  try {
    
  class FooterColumns extends HTMLElement {
    connectedCallback() {
      this.mediaQuery = window.matchMedia('(min-width: 750px)');
      this.items = Array.from(this.querySelectorAll('.footer-columns__item'));

      this.onClick = (event) => {
        const trigger = event.target.closest('.footer-columns__trigger');
        if (!trigger || !this.contains(trigger)) return;

        const item = trigger.closest('.footer-columns__item');
        this.setOpen(item, trigger.getAttribute('aria-expanded') !== 'true');
      };

      // Breakpoint changed: drop manual overrides so the new breakpoint's
      // "open by default" setting applies again.
      this.onBreakpointChange = () => {
        this.items.forEach((item) => item.removeAttribute('data-state'));
        this.syncAria();
      };

      this.addEventListener('click', this.onClick);
      this.mediaQuery.addEventListener('change', this.onBreakpointChange);
      this.syncAria();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
    }

    get defaultOpen() {
      return this.hasAttribute(this.mediaQuery.matches ? 'data-open-desktop' : 'data-open-mobile');
    }

    setOpen(item, open) {
      item.dataset.state = open ? 'open' : 'closed';
      item.querySelector('.footer-columns__trigger').setAttribute('aria-expanded', String(open));
    }

    syncAria() {
      this.items.forEach((item) => {
        const state = item.dataset.state;
        const open = state ? state === 'open' : this.defaultOpen;
        item.querySelector('.footer-columns__trigger').setAttribute('aria-expanded', String(open));
      });
    }
  }

  if (!customElements.get('footer-columns')) {
    customElements.define('footer-columns', FooterColumns);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  class HeroSplitCarousel extends HTMLElement {
    connectedCallback() {
      if (!this.classList.contains('swiper')) return;

      if (typeof Swiper === 'undefined') {
        document.addEventListener('swiper:ready', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      if (this.swiperInstance) return;

      this.swiperInstance = new Swiper(this, {
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        },
        on: {
          init: () => {
            this.classList.add('is-swiper-initialized');
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy();
        this.swiperInstance = null;
      }
    }
  }

  if (!customElements.get('hero-split-carousel')) {
    customElements.define('hero-split-carousel', HeroSplitCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newbar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const customFeatureBar = new Swiper('.hero-slider', {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 3,
      spaceBetween: 30,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        769: {
          slidesPerView: 2,
        },
        990: {
          slidesPerView: 3,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-bar"] && !Shopify.designMode) return;
  try {
    
  class TrustBarCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('.swiper');
      if (!this.swiperEl) return;

      if (typeof Swiper === 'undefined') {
        document.addEventListener('swiper:ready', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      if (this.swiperInstance) return;

      const autoplay = this.dataset.autoplay === 'true'
        ? { delay: 4000, disableOnInteraction: false }
        : false;

      // One slide at a time on mobile (with autoplay, if enabled); wider
      // screens show more items per view at once instead of forcing every
      // item into an equal-width column regardless of how much text it
      // holds — Swiper owns slide width/spacing at every breakpoint so
      // items never overflow into one another.
      this.swiperInstance = new Swiper(this.swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        autoplay,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24,
            autoplay: false
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 32,
            autoplay: false
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }
  }

  if (!customElements.get('trust-bar-carousel')) {
    customElements.define('trust-bar-carousel', TrustBarCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
